import windowDays from '@/function/calendar/calendar.window.days';
import expenseCalendarPayments from '@/function/expense/expense.calendar.payments';
import type { TypeWindowKey } from '@/function/calendar/calendar.window';
import { dropById, upsertById } from '@/store/api/base/api.cache';
import { expenseCalendarApi } from '@/store/api/expense/expense.calendar.api';
import { store, type TypeAppDispatch } from '@/store/store';
import type { TypeExpense } from '@/types/expense/types.expense';

const cachedWindows = (): TypeWindowKey[] =>
    expenseCalendarApi.util.selectCachedArgsForQuery(store.getState(), 'listExpenseCalendarWindow') as TypeWindowKey[];

export const writeExpenseCalendar = (dispatch: TypeAppDispatch, expense: TypeExpense): void => {
    for (const key of cachedWindows()) {
        const { from, to } = windowDays(key);
        const belongs = expenseCalendarPayments([expense], from, to).length > 0;
        dispatch(expenseCalendarApi.util.updateQueryData('listExpenseCalendarWindow', key, (draft) => {
            if (belongs) upsertById(draft.items, expense); else dropById(draft.items, expense.id);
        }));
    }
};

export const dropExpenseCalendar = (dispatch: TypeAppDispatch, id: string): void => {
    for (const key of cachedWindows()) {
        dispatch(expenseCalendarApi.util.updateQueryData('listExpenseCalendarWindow', key, (draft) => { dropById(draft.items, id); }));
    }
};
